/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { systemActions } from './slice';
import API from './constants';
/**
 * Get system information generator function to obtain system information
 * @param {*} param0
 */
export function* getSystemInformationGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_SYSTEM_INFORMATION, payload);
    yield put(systemActions.getSystemInformationSucceeded(response));
  } catch (error) {
    yield put(systemActions.getSystemInformationFailed(error?.message));
  }
}
/**
 * Update system information generator function to update system information
 * @param {*} param0
 */
export function* updateSystemInformationGenerator({ payload }) {
  try {
    const response = yield call(request, API.PATCH_SYSTEM_INFORMATION, payload);
    yield put(systemActions.updateSystemInformationSucceeded(response));
  } catch (error) {
    yield put(systemActions.updateSystemInformationFailed(error?.message));
  }
}
/**
 * Create system information generator function to create system information
 * @param {*} param0
 */
export function* createSystemInformationGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_SYSTEM_INFORMATION, payload);
    yield put(systemActions.createSystemInformationSucceeded(response));
  } catch (error) {
    yield put(systemActions.createSystemInformationFailed(error?.message));
  }
}
/**
 * Sync databricks generator to sync databricks
 * @param {*} param0
 */
export function* syncDatabricksDataGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_SYNC_DATABRICKS_DATA, payload);
    yield put(systemActions.syncDatabricksDataSucceeded({ response, data: payload }));
  } catch (error) {
    yield put(systemActions.deleteVisualFilterFailed(error?.message));
  }
}
/**
 * Sync currency data generator to sync currency data
 * @param {*} param0
 */
export function* syncCurrencyDataGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_SYNC_CURRENCY_DATA, payload);
    yield put(systemActions.syncCurrencyDataSucceeded({ response, data: payload }));
  } catch (error) {
    yield put(systemActions.syncCurrencyDataFailed(error?.message));
  }
}
/**
 * Sync breakdown data generator to sync breakdown data
 * @param {*} param0
 */
export function* syncBreakdownDataGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_SYNC_BREAKDOWN_DATA, payload);
    yield put(systemActions.syncBreakdownDataSucceeded({ response, data: payload }));
  } catch (error) {
    yield put(systemActions.syncBreakdownDataFailed(error?.message));
  }
}

//
export function* systemSaga() {
  yield takeLatest(systemActions.getSystemInformation.type, getSystemInformationGenerator);
  yield takeLatest(systemActions.createSystemInformation.type, createSystemInformationGenerator);
  yield takeLatest(systemActions.updateSystemInformation.type, updateSystemInformationGenerator);
  yield takeLatest(systemActions.syncDatabricksData.type, syncDatabricksDataGenerator);
  yield takeLatest(systemActions.syncCurrencyData.type, syncCurrencyDataGenerator);
  yield takeLatest(systemActions.syncBreakdownData.type, syncBreakdownDataGenerator);
}
//
export default systemSaga;
